// extracted by mini-css-extract-plugin
export default {"collection":"styles_collection__zrG3k"};